interface HighlightTextProps {
  text: string;
  highlight?: string;
}

export const HighlightText = ({ text, highlight }: HighlightTextProps) => {
  if (!highlight || highlight === "") {
    return <span>{text}</span>;
  }
  const regex = new RegExp(`(${highlight})`, "gi");
  const parts = text.split(regex);

  return (
    <span>
      {parts.filter(String).map((part, i) => {
        return regex.test(part) ? (
          <span key={i} className="font-bold">
            {part}
          </span>
        ) : (
          <span key={i}>{part}</span>
        );
      })}
    </span>
  );
};
